/*
 * Keystrokes that may reach the quantity input. Anything else is swallowed so the field
 * cannot end up holding "e", "+" or a decimal point, which type='number' otherwise allows.
 */
const allowKeyDown = (event) => {
	const code = event.code?.toLowerCase() ?? ''
	const allowed =
		code.includes('digit') ||
		code.includes('arrow') ||
		code.includes('home') ||
		code.includes('end') ||
		code.includes('backspace') ||
		code.includes('delete') ||
		code.includes('tab') ||
		(code.includes('numpad') && code.length === 7)
	if (!allowed) event.preventDefault()
}

/*
 * The − / value / + control shared by the ticket tiers and the jubileumsväska.
 *
 * The middle element stays a real <input type='number'> carrying `id`, because the form's
 * autofill-recovery pass reads these back out of the DOM by id after mount.
 */
const Stepper = ({
	id,
	label,
	value,
	onDecrement,
	onIncrement,
	inputProps,
	onInputChange,
	disabled = false,
	canDecrement = true,
	canIncrement = true,
}) => (
	<div className='hx-stepper'>
		<button
			type='button'
			className='hx-stepper__btn'
			aria-label={`Ta bort en ${label}`}
			disabled={disabled || !canDecrement}
			onClick={onDecrement}
		>
			<span aria-hidden='true'>−</span>
		</button>
		<input
			id={id}
			type='number'
			className='hx-stepper__value'
			aria-label={`Antal ${label}`}
			disabled={disabled}
			onKeyDown={allowKeyDown}
			{...inputProps}
			onChange={(event) => {
				/* react-hook-form's own handler has to run first: spreading register() and then
				   replacing onChange (as this component used to) meant a typed quantity was
				   clamped but never recorded in form state. */
				inputProps?.onChange?.(event)
				onInputChange?.(event)
			}}
		/>
		<button
			type='button'
			className='hx-stepper__btn'
			aria-label={`Lägg till en ${label}`}
			disabled={disabled || !canIncrement}
			onClick={onIncrement}
		>
			<span aria-hidden='true'>+</span>
		</button>
	</div>
)

export default Stepper
